import React from 'react';
import style from '../css/Services.module.css';
import { Service_list_bang } from '../data/Service_List_bang';
import { Service_list } from '../data/Service_List';
import { Link } from 'react-router-dom';

function Services() {
	return (
		<div>
			<p className={style.list}>Our Services</p>
			<div className={style.container}>
				{Service_list_bang.map((service, index) => (
					<Link
						to={'/book-repair'}
						key={service.id}
						className={style.container1}
					>
						<img
							src={service.img}
							alt={service.title}
							className={style.image}
						/>
						<p>{service.title}</p>
					</Link>
				))}
			</div>
		</div>
	);
}

export default Services;
